/** @flow */

import {
  GetDepartmentSpecificScript,
  GetDepartmentSpecificScriptSuccess,
  GetDepartmentSpecificScriptError,
  GetDepartmentSpecificScripts,
  GetDepartmentSpecificScriptsSuccess,
  GetDepartmentSpecificScriptsError,
  NewDepartmentSpecificScript,
  NewDepartmentSpecificScriptAssignments,
  ShowAddDepartmentSpecificScriptModal,
  UpdateDepartmentSpecificScriptDraft,
  SetDepartmentSpecificScriptAssignments,
  AddDepartmentSpecificScript,
  AddDepartmentSpecificScriptSuccess,
  AddDepartmentSpecificScriptError,
  GetDepartmentSpecificScriptActiveSuccess,
  GetDepartmentSpecificScriptActiveError,
  ShowDepartmentSpecificScriptEditModal,
  SetShowDiscardDepartmentSpecificScriptModal,
  SetShowCancelDepartmentSpecificScriptModal,
  SetShowCancelDiscardDepartmentSpecificScriptModal,
  StartDepartmentSpecificScriptDraftSuccess,
  DuplicateDepartmentSpecificScriptSuccess,
  SetShowDisableDepartmentSpecificScriptModal,
  ShowEditDepartmentSpecificScriptAssignmentsModal,
  UpdateDepartmentSpecificScript,
  UpdateDepartmentSpecificScriptSuccess,
  UpdateDepartmentSpecificScriptError,
  SetDepartmentSpecificScriptDraft,
  DisableDepartmentSpecificScriptError,
  SetShowSubmitDepartmentSpecificScriptModal,
  CancelDepartmentSpecificScriptReviewError,
  StartDepartmentSpecificScriptDraftError,
  SubmitDepartmentSpecificScriptForReviewError,
  DuplicateDepartmentSpecificScriptError,
  DiscardDepartmentSpecificScriptDraftError,
  CancelDepartmentSpecificScriptReviewAndDiscardError,
  UpdateDepartmentSpecificScriptAssignmentsError,
  SetDepartmentSpecificScriptDraftAssignments,
} from "@modules/service/constants/actions";
import * as departmentSpecificScriptsReducers from "./reducers";
import initialState from "./state";
import type { DepartmentSpecificScriptsState } from "./types";
import { cloneObject } from "@utils/object";

export default (
  state: DepartmentSpecificScriptsState = initialState,
  action: Object,
): DepartmentSpecificScriptsState => {
  const act = {
    [GetDepartmentSpecificScripts]:
      departmentSpecificScriptsReducers.onGetDepartmentSpecificScripts,
    [GetDepartmentSpecificScriptsSuccess]:
      departmentSpecificScriptsReducers.onGetDepartmentSpecificScriptsSuccess,
    [GetDepartmentSpecificScriptsError]:
      departmentSpecificScriptsReducers.onGetDepartmentSpecificScriptsError,
    [NewDepartmentSpecificScript]: departmentSpecificScriptsReducers.onNewDepartmentSpecificScript,
    [NewDepartmentSpecificScriptAssignments]:
      departmentSpecificScriptsReducers.onNewDepartmentSpecificScriptAssignments,
    [ShowAddDepartmentSpecificScriptModal]:
      departmentSpecificScriptsReducers.onShowAddDepartmentSpecificScriptModal,
    [UpdateDepartmentSpecificScriptDraft]:
      departmentSpecificScriptsReducers.onUpdateDepartmentSpecificScriptDraft,
    [SetDepartmentSpecificScriptAssignments]:
      departmentSpecificScriptsReducers.onSetDepartmentSpecificScriptAssignments,
    [SetDepartmentSpecificScriptDraftAssignments]:
      departmentSpecificScriptsReducers.onSetDepartmentSpecificScriptDraftAssignments,
    [AddDepartmentSpecificScript]: departmentSpecificScriptsReducers.onAddDepartmentSpecificScript,
    [AddDepartmentSpecificScriptSuccess]:
      departmentSpecificScriptsReducers.onAddDepartmentSpecificScriptSuccess,
    [AddDepartmentSpecificScriptError]:
      departmentSpecificScriptsReducers.onAddDepartmentSpecificScriptError,
    [GetDepartmentSpecificScriptActiveSuccess]:
      departmentSpecificScriptsReducers.onGetDepartmentSpecificScriptActiveSuccess,
    [GetDepartmentSpecificScriptActiveError]:
      departmentSpecificScriptsReducers.onGetDepartmentSpecificScriptActiveError,
    [ShowDepartmentSpecificScriptEditModal]:
      departmentSpecificScriptsReducers.onShowDepartmentSpecificScriptEditModal,
    [SetShowDiscardDepartmentSpecificScriptModal]:
      departmentSpecificScriptsReducers.onSetShowDiscardDepartmentSpecificScriptModal,
    [SetShowCancelDepartmentSpecificScriptModal]:
      departmentSpecificScriptsReducers.onSetShowCancelDepartmentSpecificScriptModal,
    [SetShowCancelDiscardDepartmentSpecificScriptModal]:
      departmentSpecificScriptsReducers.onSetShowCancelDiscardDepartmentSpecificScriptModal,
    [SetShowDisableDepartmentSpecificScriptModal]:
      departmentSpecificScriptsReducers.onSetShowDisableDepartmentSpecificScriptModal,
    [SetShowSubmitDepartmentSpecificScriptModal]:
      departmentSpecificScriptsReducers.onSetShowSubmitDepartmentSpecificScriptModal,
    [ShowEditDepartmentSpecificScriptAssignmentsModal]:
      departmentSpecificScriptsReducers.onShowEditDepartmentSpecificScriptAssignmentsModal,
    [StartDepartmentSpecificScriptDraftSuccess]:
      departmentSpecificScriptsReducers.onStartDepartmentSpecificScriptDraftSuccess,
    [DuplicateDepartmentSpecificScriptSuccess]:
      departmentSpecificScriptsReducers.onDuplicateDepartmentSpecificScriptSuccess,
    [GetDepartmentSpecificScript]: departmentSpecificScriptsReducers.onGetDepartmentSpecificScript,
    [GetDepartmentSpecificScriptSuccess]:
      departmentSpecificScriptsReducers.onGetDepartmentSpecificScriptSuccess,
    [GetDepartmentSpecificScriptError]:
      departmentSpecificScriptsReducers.onGetDepartmentSpecificScriptError,
    [UpdateDepartmentSpecificScript]:
      departmentSpecificScriptsReducers.onUpdateDepartmentSpecificScript,
    [UpdateDepartmentSpecificScriptSuccess]:
      departmentSpecificScriptsReducers.onUpdateDepartmentSpecificScriptSuccess,
    [UpdateDepartmentSpecificScriptError]:
      departmentSpecificScriptsReducers.onUpdateDepartmentSpecificScriptError,
    [SetDepartmentSpecificScriptDraft]:
      departmentSpecificScriptsReducers.onSetDepartmentSpecificScriptDraft,
    [DisableDepartmentSpecificScriptError]:
      departmentSpecificScriptsReducers.onDisableDepartmentSpecificScriptError,
    [CancelDepartmentSpecificScriptReviewError]:
      departmentSpecificScriptsReducers.onCancelDepartmentSpecificScriptReviewError,
    [StartDepartmentSpecificScriptDraftError]:
      departmentSpecificScriptsReducers.onStartDepartmentSpecificScriptDraftError,
    [SubmitDepartmentSpecificScriptForReviewError]:
      departmentSpecificScriptsReducers.onSubmitDepartmentSpecificScriptForReviewError,
    [DuplicateDepartmentSpecificScriptError]:
      departmentSpecificScriptsReducers.onDuplicateDepartmentSpecificScriptError,
    [DiscardDepartmentSpecificScriptDraftError]:
      departmentSpecificScriptsReducers.onDiscardDepartmentSpecificScriptDraftError,
    [CancelDepartmentSpecificScriptReviewAndDiscardError]:
      departmentSpecificScriptsReducers.onCancelDepartmentSpecificScriptReviewAndDiscardError,
    [UpdateDepartmentSpecificScriptAssignmentsError]:
      departmentSpecificScriptsReducers.onUpdateDepartmentSpecificScriptAssignmentsError,
  };

  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
